'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Input = require('../Input/Input.js');
require('./_index.scss.js');

var _excluded = ["onLocate", "onSearch"];
var CLASSNAME = 'varta-input-location-search',
    cnButtonLocate = "".concat(CLASSNAME, "__button-locate"),
    cnButtonSearch = "".concat(CLASSNAME, "__button-search"),
    cnButtonWrapper = "".concat(CLASSNAME, "__button-wrapper");
/**
 * 
 */

var InputLocationSearch = /*#__PURE__*/function (_Input) {
  _rollupPluginBabelHelpers.inherits(InputLocationSearch, _Input);

  var _super = _rollupPluginBabelHelpers.createSuper(InputLocationSearch);

  function InputLocationSearch() {
    var _thisSuper, _this;

    _rollupPluginBabelHelpers.classCallCheck(this, InputLocationSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, _rollupPluginBabelHelpers.get((_thisSuper = _rollupPluginBabelHelpers.assertThisInitialized(_this), _rollupPluginBabelHelpers.getPrototypeOf(InputLocationSearch.prototype)), "state", _thisSuper)), {}, {
      value: _this.props.value
    }));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "className", CLASSNAME);

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onSearch", function () {
      var onSearch = _this.props.onSearch;
      var value = _this.state.value;
      onSearch(value);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(InputLocationSearch, [{
    key: "onChange",
    value: function onChange(e) {
      _rollupPluginBabelHelpers.get(_rollupPluginBabelHelpers.getPrototypeOf(InputLocationSearch.prototype), "onChange", this).call(this, e);

      this.setState({
        value: e.target.value
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var onLocate = this.props.onLocate;
      return /*#__PURE__*/React__default.createElement("div", {
        className: cnButtonWrapper
      }, /*#__PURE__*/React__default.createElement("button", {
        className: cnButtonSearch,
        onClick: this.onSearch
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "search-alt",
        size: "xs"
      })), typeof navigator !== 'undefined' && navigator.geolocation && /*#__PURE__*/React__default.createElement("button", {
        className: cnButtonLocate,
        onClick: onLocate
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "location",
        size: "xs"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onLocate = _this$props.onLocate,
          onSearch = _this$props.onSearch,
          rest = _rollupPluginBabelHelpers.objectWithoutProperties(_this$props, _excluded);

      return _rollupPluginBabelHelpers.get(_rollupPluginBabelHelpers.getPrototypeOf(InputLocationSearch.prototype), "render", this).call(this, rest);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.controlledValue !== prevState.value) {
        return _rollupPluginBabelHelpers.objectSpread2({
          value: nextProps.controlledValue
        }, _rollupPluginBabelHelpers.get(_rollupPluginBabelHelpers.getPrototypeOf(InputLocationSearch), "getDerivedStateFromProps", this).call(this, nextProps, prevState));
      }

      return _rollupPluginBabelHelpers.objectSpread2({}, _rollupPluginBabelHelpers.get(_rollupPluginBabelHelpers.getPrototypeOf(InputLocationSearch), "getDerivedStateFromProps", this).call(this, nextProps, prevState));
    }
  }]);

  return InputLocationSearch;
}(Input);
InputLocationSearch.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, Input.propTypes), {}, {
  /** Callback function */
  onLocate: PropTypes.func.isRequired,

  /** Callback function */
  onSearch: PropTypes.func.isRequired
});
InputLocationSearch.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, Input.defaultProps), {}, {
  onLocate: function onLocate() {
    return void 0;
  },
  onSearch: function onSearch() {
    return void 0;
  }
});

module.exports = InputLocationSearch;
